import REQ from '../../../utils/REQ';
import { PageBase } from './base';

export const PageLoading = () => {
  return <PageBase req={REQ.PENDING} />;
};
